(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/form.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/form.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => ( components_form)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_React_namespaceObject = window["React"];
  var external_React_default = __webpack_require__.n(external_React_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["className", "children", "isVertical", "onSubmit", "onValidate", "setError"];
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }

  const Form = _ref => {
    let {
        className,
        children,
        isVertical,
        onSubmit,
        onValidate,
        setError
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    const classes = ['form'];
    const validationRefs = external_React_default().useRef({});
    const [form, setForm] = external_React_default().useState({});
    const setErrorString = setError && JSON.stringify(setError);
    if (className) {
      classes.push(className);
    }
    if (isVertical) {
      classes.push('form-vertical');
    }
    external_React_default().useEffect(() => {
      const errors = {};
      if (setErrorString) {
        const setErrorObject = JSON.parse(setErrorString);
        for (const errorName in setErrorObject) {
          if (Object.prototype.hasOwnProperty.call(setErrorObject, errorName)) {
            errors[errorName] = {
              errorMessage: setErrorObject[errorName],
              isValid: false
            };
          }
        }
        setForm(_objectSpread(_objectSpread({}, form), errors));
      }
    }, [setError]);
    const handleBlur = (e, onBlur) => {
      if (typeof svs === 'undefined' || svs.core.data.capabilities.formFactor === 'desktop') {
        const name = e.target.name;
        const value = e.target.value;
        const validationResult = validationRefs.current[name] && validationRefs.current[name].validate('onBlur', value);
        setForm(_objectSpread(_objectSpread({}, form), {}, {
          [name]: {
            errorMessage: validationResult.errorMessage,
            isValid: validationResult.isValid
          }
        }));
        if (onValidate) {
          onValidate(name, validationResult.isValid, validationResult.errorMessage);
        }
      }
      if (onBlur) {
        onBlur(e);
      }
    };
    const handleChange = (e, onChange) => {
      const name = e.target.name;
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        [name]: {
          errorMessage: '',
          isValid: true
        }
      }));
      if (onChange) {
        onChange(e);
      }
    };
    const handleFocus = (e, onFocus) => {
      if (onFocus) {
        onFocus(e);
      }
    };
    const onSubmitHandler = e => {
      const newFormData = {};
      for (const input in validationRefs.current) {
        if (Object.prototype.hasOwnProperty.call(validationRefs.current, input)) {
          const inputRef = validationRefs.current[input];
          if (inputRef && inputRef.validate) {
            const validateResult = inputRef.validate('onSubmit', inputRef.element.value);
            newFormData[validateResult.name] = {
              errorMessage: validateResult.errorMessage,
              isValid: validateResult.isValid,
              value: inputRef.element.value
            };
          }
        }
      }
      setForm(_objectSpread(_objectSpread({}, form), newFormData));
      if (onSubmit) {
        onSubmit(e, newFormData, !Object.values(newFormData).filter(f => !f.isValid)[0]);
      }
    };
    const register = (name, validate) => element => {
      validationRefs.current[name] = null;
      if (element) {
        validationRefs.current[name] = {
          element,
          validate
        };
      }
    };
    return external_React_default().createElement("form", _extends({
      className: classes.join(' '),
      onSubmit: onSubmitHandler
    }, props), external_React_default().createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Provider, {
      value: {
        form,
        handleBlur,
        handleChange,
        handleFocus,
        register
      }
    }, children));
  };
  Form.propTypes = {
    children: external_PropTypes_default().node,
    className: external_PropTypes_default().string,
    isVertical: external_PropTypes_default().bool,
    onSubmit: external_PropTypes_default().func,
    onValidate: external_PropTypes_default().func,
    setError: external_PropTypes_default().shape({
      errorMessage: external_PropTypes_default().string,
      name: external_PropTypes_default().string
    })
  };
  Form.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "Form",
    "props": {
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isVertical": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "onSubmit": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onValidate": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "setError": {
        "description": "",
        "type": {
          "name": "shape",
          "value": {
            "errorMessage": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": false
            }
          }
        },
        "required": false
      }
    }
  };
  const components_form = Form;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Form = __webpack_exports__["default"];
})();

 })(window);